export default {
  backToDetailsLinkText: '22022019-142905-0026',
  headerTextExistingUser: '11042017-054442-3121',
  headerTextNewAccount: '19122018-152801-0073',
  headerTextGuest: '22022019-142905-0027'
};
